var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClocktime = function SvgClocktime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.668a4.68 4.68 0 0 0 4.667-4.667A4.68 4.68 0 0 0 6 1.335 4.68 4.68 0 0 0 1.333 6 4.68 4.68 0 0 0 6 10.668Zm0-10.5c3.208 0 5.833 2.625 5.833 5.833 0 3.209-2.625 5.834-5.833 5.834S.167 9.21.167 6C.167 2.793 2.792.168 6 .168ZM8.917 7.11l-.409.758-3.091-1.692V3.085h.875V5.65L8.917 7.11Z",
    fill: "var(--default-text-color)"
  })));
};

export default SvgClocktime;